import { destroy } from './destroy';
import { mount } from './mount';

export type { WidgetMountOptions } from './types/config';
export type { WidgetEventPayload } from './types/events';
export type { WidgetUiState } from './types/state';
export type { WidgetInstance } from './widget';

export { mount, destroy };

export const CryptoPayWidget = {
  mount,
  destroy
};

declare global {
  interface Window {
    CryptoPayWidget?: typeof CryptoPayWidget;
  }
}

if (typeof window !== 'undefined') {
  window.CryptoPayWidget = CryptoPayWidget;
}

export default CryptoPayWidget;